import React from 'react';
import { Receiver as ReportReceiverShape } from '../../shapes/report';

class ReportSummaryReceiver extends React.Component {

  render() {
    return (
      <React.Fragment>
        <tr>
          <td>{this.props.receiver.receiver || 'Not Provided'}</td>
          <td>{this.props.receiver.identifier || 'Not Provided'}</td>
          <td>{this.props.receiver.net}</td>
          <td>{this.props.receiver.tax}</td>
        </tr>
      </React.Fragment>
    )
  }

}

ReportSummaryReceiver.propTypes = {
  receiver: ReportReceiverShape.isRequired
};

export default ReportSummaryReceiver;


// WEBPACK FOOTER //
// ./src/views/report/report-summary-receiver.js